import { dayjs } from '@uhg-abyss/web/tools/dayjs';

export const DefaultSaveEventPayload = {
  actualRecordCount: 0,
  eventTrackerStatus: 'INACTIVE',
  eventTypeCode: 'OTHER',
  expectedRecordCount: 0,
  impactedSystems: [],
  notes: '',
  startDate: dayjs(new Date()).format('YYYY-MM-DD'),
  title: '',
};
